import React from "react";
import loadable from "@loadable/component";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../contants/Endpoints";
import useGetHook from "../../customHooks/useGetHook";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { productFormValidation } from "../../utils/formValidation";
const AddProductComponent = loadable(
  () => import("../../components/Product/AddProduct")
);

type Props = {};

const AddProduct = (props: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(productFormValidation),
    defaultValues: {
      name: "",
      code: "",
      category: "",
      weight: "",
      purity: "",
    },
  });

  const { isPostLoading, mutateAsync, postData } = usePostHook({
    queryKey: ["product"],
    navigateURL: "/product",
  });
  const { data: categoryData, isPending: categoryLoading } = useGetHook({
    queryKey: ["category"],
    url: `${APIS.CATEGORY}`,
    params: {},
  });
  const handleAddProduct = async (values: any) => {
    const url = APIS.PRODUCT;
    const formData = {
      name: values.name,
      code: values.code,
      category: values?.category,
      purity: `${values?.purity}`,
      weight: values?.weight,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error("Error creating category:", err);
    }
  };

  return (
    <AddProductComponent
      handleAddProduct={handleAddProduct}
      categoryData={categoryData}
      isPostLoading={isPostLoading}
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
    />
  );
};

export default AddProduct;
